<lib-sales-insights-card
  [cardTitle]="config?.title"
  [subtitle]="totals"
  [loading]="loading"
  [error]="error"
  [empty]="empty"
>
  @if (canExport) {
    <button cardActions type="button" class="btn btn-sm si-orders__export" [disabled]="exporting" (click)="exportExcel()">
      <i class="fa-solid fa-file-excel me-1"></i>{{ 'SALES_INSIGHTS_EXPORT_EXCEL' | translate }}
    </button>
  }
  @if (searchable) {
    <lib-sales-insights-list-search cardToolbar [value]="query" (valueChange)="search($event)"></lib-sales-insights-list-search>
  }
  <div class="table-responsive si-orders">
    <table class="table table-sm table-hover align-middle mb-0">
      <thead>
        <tr>
          @for (column of columns; track column) {
            <th scope="col" [class.text-end]="isNumber(column)">{{ columnLabelKey(column) | translate }}</th>
          }
        </tr>
      </thead>
      <tbody>
        @for (row of visibleRows; track row.orderId + '|' + row.customerId) {
          <tr>
            @for (column of columns; track column) {
              <td [class.text-end]="isNumber(column)" [class.si-orders__number]="isNumber(column)">
                {{ cell(row, column) }}
                @if (column === 'valueLocal' && row.currency) {
                  <span class="si-orders__sub">{{ row.currency }}</span>
                }
                @if (column === 'customerName' && row.customerName && columns.indexOf('customerId') < 0) {
                  <span class="si-orders__sub">{{ row.customerId }}</span>
                }
              </td>
            }
          </tr>
        } @empty {
          <tr>
            <td [attr.colspan]="columns.length" class="text-body-secondary">{{ 'SALES_INSIGHTS_LIST_NO_MATCHES' | translate }}</td>
          </tr>
        }
      </tbody>
    </table>
  </div>
  @if (rows.length > visibleCount) {
    <div class="si-orders__more">
      <button type="button" class="btn btn-outline-secondary btn-sm" (click)="showMore()">
        {{ 'SALES_INSIGHTS_SHOW_MORE' | translate: { shown: visibleCount, total: rows.length } }}
      </button>
    </div>
  }
</lib-sales-insights-card>
